<script>
import ErrorsControl from 'frontend/common/ea-form-controls/_errors-control.vue'
import Mapbox from 'frontend/common/maps/mapbox/ea-mapbox.vue'
import Route from 'frontend/common/maps/mapbox/map-components/route.vue'
import { inject, onMounted } from 'vue'

import { DurationRulesService } from '../duration-rules-service'
import { useDurationRulePreview } from './use-duration-rule-preview'

export default {
  name: 'QmicDurationPreview',
  props: {
    durationRule: { type: Object, required: true },
    departureAt: { type: Object },
    arrivalAt: { type: Object },
    providedStamp: String,
  },
  setup(props) {
    const blocker = inject('blocker')
    const durationRulesService = new DurationRulesService({ blocker })

    const { arrivalAtCeiled, duration, fetchPreview, route, routeMetadata, serverErrors } =
      useDurationRulePreview(props.durationRule, durationRulesService)

    onMounted(() => {
      fetchPreview(props.durationRule, { withRoute: true })
    })

    return {
      arrivalAtCeiled,
      duration,
      route,
      routeMetadata,
      serverErrors,
    }
  },
  components: {
    ErrorsControl,
    Mapbox,
    Route,
  },
}
</script>

<template lang="pug">
.qmic-duration-preview
  .row(v-if="routeMetadata")
    .col-auto
      span.text-nowrap Pick-up:
        .bold
          formatted-time(:t="routeMetadata.departureAt" :tz="routeMetadata.departureTimeZone")
    .col-auto
      span.text-nowrap Drop-off:
        .bold
          formatted-time(
            :t="providedStamp == 'departureAt' ? arrivalAtCeiled : routeMetadata.arrivalAt"
            :tz="routeMetadata.arrivalTimeZone"
          )
    .col-auto
      span.text-nowrap Time:
        .bold.text-nowrap {{ duration }}
  .mt-2
    errors-control(v-for="error in Object.values(serverErrors || {})" :additionalErrors="error")
    mapbox(v-if="route" :height="300")
      route(:routeGeometry="route" focusOnShow)
</template>
